export const colorBox = {
    financeIncome: [{
        moduleType: 'VisitEfficiency',
        title: '访视效率',
        backgroundImage: 's3',
        unit: '',
        showCompare: true,
        toType: 'VisitEfficiency',
    }, {
        moduleType: 'EmpOutPutRate',
        title: '人员产出率',
        backgroundImage: 'o3',
        unit: '%',
        showCompare: true,
        allBusiness: true,
        toType: 'EmpOutPutRate',
    }, ],
};

export const chartBox = {
    financeIncome: [{
        moduleType: 'VisitEfficiency',
        title: '访视效率',
        chartTypes: ['column', 'line'],
        unit: '',
        toType: 'VisitEfficiency'
    }, {
        moduleType: 'EmpOutPutRate',
        title: '人员产出率',
        allBusiness: true,
        chartTypes: ['column', 'line'],
        unit: '%',
        toType: 'EmpOutPutRate'
    }],
}

export const ColorParams = {
    financeIncome: {
        lineOfBusiness: '-1',
        contractTypeId: '-1',
        analysisDimension: 'GLOBAL',
    },
};

export const ChartParams = {
    financeIncome: {
        lineOfBusiness: '-1',
        displayType: 'Difference',
        contractTypeId: '-1',
        analysisDimension: 'GLOBAL',
    },
};

export const DefaultParams = {
    financeIncome: {
        statisticalRange: 'PROJECT',
    },
};


// WEBPACK FOOTER //
// ./src/components/homePage/constants/people.js